import { render } from "./HeroiconsOutlineCog.vue?vue&type=template&id=983eecb2"
const script = {}

import exportComponent from "/home/roland/vscode/yachtbroker/portal/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCog.vue"]])

export default __exports__